export const PLAN_STORE = 'PLAN_STORE';
export const PLAN_UPDATE = 'PLAN_UPDATE';
export const PLAN_DESTROY = 'PLAN_DESTROY';
